import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFeather = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      fill='currentColor'
      d='m20.24 12.24-.707-.707h-.001zM15.995 1.992v-1zM11.75 3.75l-.707-.707zM5 10.5l-.707-.707A1 1 0 0 0 4 10.5zM5 19H4a1 1 0 0 0 1 1zm8.5 0v1a1 1 0 0 0 .708-.294zm3.207-10.293a1 1 0 0 0-1.414-1.414zM1.293 21.293a1 1 0 1 0 1.414 1.414zM17.5 16a1 1 0 1 0 0-2zM9 14a1 1 0 1 0 0 2zm11.947-1.053a7 7 0 0 0 2.051-4.952h-2c0 1.327-.527 2.6-1.465 3.538zm2.051-4.952a7 7 0 0 0-2.05-4.952l-1.415 1.414a5 5 0 0 1 1.465 3.538zm-2.05-4.952A7 7 0 0 0 15.994.992v2c1.327 0 2.6.527 3.538 1.465zM15.994.992a7 7 0 0 0-4.952 2.05l1.414 1.415a5 5 0 0 1 3.538-1.465zm-4.952 2.05-6.75 6.75 1.414 1.415 6.75-6.75zM4 10.5V19h2v-8.5zM5 20h8.5v-2H5zm9.208-.294 6.74-6.76-1.416-1.412-6.74 6.76zm1.085-12.413-14 14 1.414 1.414 14-14zM17.5 14H9v2h8.5z'
    />
  </svg>
);
export default SvgFeather;
